import React, { useState } from "react";
import editIcon from "../../../assets/design-revamp-company/add-edit/editIcon.svg";
import deleteIcon from "../../../assets/design-revamp-company/add-edit/deleteIcon.svg";
import saveIcon from "../../../assets/design-revamp-company/add-edit/saveIcon.svg";
import InfoBox from "../components/InfoBox";
import LocationTabs from "../components/LocationTabs";
import InputField from "../components/InputField";
import { useTranslation } from "react-i18next";
import "../Facility/facility.css";
import EmailField from "../components/EmailField";
import ScopeComponent from "../components/ScopeComponent";
import { useUserAccess } from "../../../components/WriteAccessContext";

const Franchise = ({
  initialData,
  isNewFacility,
  onFormDataChange,
  handleSave,
  errorMessage,
  setCurrentName,
  setCutOffAddress,
  handleDelete,
}) => {
  const { t } = useTranslation();
  const [franchiseName, setFranchiseName] = useState(initialData.franchiseName);
  const [franchiseHolder, setFranchiseHolder] = useState(
    initialData.franchiseHolder
  );
  const [vatNumber, setVatNumber] = useState(initialData.vatNumber);
  const [countryOrigin, setCountryOrigin] = useState(initialData.countryOrigin);
  const [scope1, setScope1] = useState(initialData.scope1);
  const [scope2, setScope2] = useState(initialData.scope2);
  const [isEditing, setIsEditing] = useState(isNewFacility);
  const { userAccess } = useUserAccess();

  const handleInputChange = (field, value) => {
    switch (field) {
      default:
        switch (field) {
          case "franchiseName":
            setFranchiseName(value);
            setCurrentName(value);
            break;
          case "franchiseHolder":
            setFranchiseHolder(value);
            break;
          case "vatNumber":
            setVatNumber(value);
            break;
          case "countryOrigin":
            setCountryOrigin(value);
            setCutOffAddress(value);
            break;
          case "scope1":
            setScope1(value);
            break;
          case "scope2":
            setScope2(value);
            break;
          default:
            break;
        }
        break;
    }
    onFormDataChange({
      franchiseName: field === "franchiseName" ? value : franchiseName,
      franchiseHolder: field === "franchiseHolder" ? value : franchiseHolder,
      vatNumber: field === "vatNumber" ? value : vatNumber,
      countryOrigin: field === "countryOrigin" ? value : countryOrigin,
      scope1: field === "scope1" ? value : scope1,
      scope2: field === "scope2" ? value : scope2,
    });
  };

  const getLocationTabs = () => {
    const tabs = [];

    if (franchiseName) tabs.push(franchiseName);
    if (countryOrigin) tabs.push(countryOrigin);

    return tabs;
  };
  return (
    <div className="facility-container">
      <div className="header">
        <h2>{t("FRANCHISES")}</h2>
        {!isNewFacility && (
          <div className="header-buttons">
            {isEditing ? (
              <button
                className="close-button"
                onClick={() => setIsEditing(false)}
              >
                <img src={deleteIcon} alt="" width={28} height={27} />
              </button>
            ) : (
              userAccess === "write" && (
                <div style={{ display: "flex" }}>
                  <button
                    className="edit-button"
                    onClick={() => setIsEditing(true)}
                  >
                    <img src={editIcon} alt="" width={28} height={27} />
                  </button>
                  <button
                    className="close-button"
                    onClick={handleDelete}
                    style={{ marginLeft: 0 }}
                  >
                    <img src={deleteIcon} alt="" width={28} height={27} />
                  </button>
                </div>
              )
            )}
          </div>
        )}
      </div>
      <InfoBox t={t} text={"FRANCHISE_DESC"} />
      <LocationTabs locations={getLocationTabs()} />
      <div className="form-container">
        <InputField
          label={`${t("FRANCHISE_NAME")}`}
          value={franchiseName}
          onChange={(value) => handleInputChange("franchiseName", value)}
          isEditing={isEditing}
        />
        <InputField
          label={`${t("FRANCHISE_HOLDER")}`}
          value={franchiseHolder}
          onChange={(value) => handleInputChange("franchiseHolder", value)}
          isEditing={isEditing}
        />
        <InputField
          label={`${t("VAT_NUMBER")}`}
          value={vatNumber}
          onChange={(value) => handleInputChange("vatNumber", value)}
          isEditing={isEditing}
        />
        <InputField
          label={`${t("COUNTRY_ORIGIN")}`}
          value={countryOrigin}
          onChange={(value) => handleInputChange("countryOrigin", value)}
          isEditing={isEditing}
        />
        <EmailField
          label={"Emissions (Provided by Investee)"}
          secondLabel={"Click mail to send request >"}
          isFranchise={true}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <ScopeComponent
            label={"Scope 1"}
            value={scope1}
            onChange={(value) => handleInputChange("scope1", value)}
            isEditing={isEditing}
            bgColorLabel={"rgba(255, 255, 255, 0.8)"}
            colorLabel={"#2C5B47"}
          />
          <ScopeComponent
            label={"Scope 2"}
            value={scope2}
            onChange={(value) => handleInputChange("scope2", value)}
            isEditing={isEditing}
            bgColorLabel={"rgba(131, 167, 152, 0.8)"}
            colorLabel={"white"}
          />
        </div>
      </div>
      {userAccess === "write" && (
        <div className="footer">
          <button className="save-button" onClick={handleSave}>
            <img src={saveIcon} alt="" width={28} height={28} />
          </button>
        </div>
      )}
    </div>
  );
};

export default Franchise;
